module.exports = __webpack_public_path__ + "media/SessionStartSoundManyBells.b0f2169d.mp3";